import { BillService } from "./service/bill";
import { CustomerService } from "./service/customer";
import { FranchiserService } from "./service/franchiser";
import { PaymentService } from "./service/payment";
import { PageOrderTag } from "./page/order-tag";
import { PageOrderTagProcessForm } from "./page/order-tag-process-form";
import { PageRegisterTag} from "./page/payment/register-tag/rs/tas";
import { PagePaymentProcessForm } from "./page/payment/process-form";
import { PageCustomerProfileBills } from "./page/customer-profile/bills";
import { PageCustomerProfileCards } from "./page/customer-profile/cards";
import { PageCustomerProfileTags } from "./page/customer-profile/tags/index";
import { PageCustomerProfileHistory } from "./page/customer-profile/history/index";
import { PageProcessFormMonri } from "./page/payment/process-form-monri/index";
import { PageFrontPage } from "./page/front-page";
import { PagePaymentLoadingForm } from "./page/payment/success-response";
import {PageCustomerProfileInfo} from "./page/customer-profile/personal-info";
import {PageLogin} from "./page/login/personal-info";
import {PageCustomerProfilePrepaidRefundRequest} from "./page/customer-profile/prepaid-refund-request";
import {PageTagOrder} from "./page/tag-order";
import {PageCustomerCameras} from "./page/customer-profile/cameras";
/*** General setup START ***/
$.ajaxSetup({
  headers: {
    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
  },
});
window.API = {};
// Services
API.service = {
  bill: BillService,
  customer: CustomerService,
  franchiser: FranchiserService,
  // actionLog: ActionLogService,
  payment: PaymentService,
};
// Page manager for routes
API.pageManager = {};

// Events
$("#modal_delete").on("show.bs.modal", function (e) {
  $(this).find(".btn-ok").attr("href", $(e.relatedTarget).data("href"));
});

/*** General setup END ***/

/*** Init pages controllers ***/
API.pageManager.orderTag = PageOrderTag;
API.pageManager.orderTagProcessForm = PageOrderTagProcessForm;
API.pageManager.registerTag = PageRegisterTag;
API.pageManager.paymentProcessForm = PagePaymentProcessForm;
API.pageManager.customerProfileBills = PageCustomerProfileBills;
API.pageManager.customerProfileCards = PageCustomerProfileCards;
API.pageManager.cutomerProfileTags = PageCustomerProfileTags;
API.pageManager.customerProfileHistory = PageCustomerProfileHistory;
API.pageManager.processFormMonri = PageProcessFormMonri;
API.pageManager.frontPage = PageFrontPage;
API.pageManager.paymentLoadingForm = PagePaymentLoadingForm;
API.pageManager.customerProfileInfo = PageCustomerProfileInfo;
API.pageManager.login = PageLogin;
API.pageManager.customerProfilePrepaidRefundRequest = PageCustomerProfilePrepaidRefundRequest;
API.pageManager.tagOrder = PageTagOrder;
API.pageManager.customerCameras = PageCustomerCameras;